<template>
  <div class="app">
    <div class="main">
      <div class="login">
        <div class="login-con">
          <div class="login-div-head masked">
            <p class="login-div-head-p1">数据中心智慧综合管理平台</p>
            <p class="login-div-head-p2">SHUJUZHONGXINZHIHUIZONGHEGUANLI</p>
          </div>
          <div class="login-card">
            <p class="login-card-title">登录</p>
            <div class="login-card-input-view">
              <div class="login-card-input-view-img">
                <img src="../../assets/login/yonghuming.png" alt="" />
              </div>
              <div class="login-card-input">
                <input
                  type="text"
                  v-model="LoginCode"
                  value=""
                  placeholder="请输入用户名"
                />
              </div>
            </div>
            <div class="login-card-input-view">
              <div class="login-card-input-view-img">
                <img src="../../assets/login/mima.png" alt="" />
              </div>
              <div class="login-card-input">
                <input
                  @focus="changeInputType"
                  :type="inputType"
                  v-model="LoginPassword"
                  value=""
                  placeholder="请输入密码"
                />
              </div>
            </div>
            <div class="login-card-input-checkbox">
              <Checkbox v-model="remember">记住密码</Checkbox>
            </div>
            <div class="login-card-input-but">
              <Button @click="Login()" :loading="loading">登录</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UserLogin } from "@/api/url_api.js";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      LoginCode: "",
      LoginPassword: "",
      loading: false,
      inputType: "text",
      remember: true,
    };
  },

  computed: {},

  mounted() {
    let _this = this;
    let data = Cookies.get("Remember")
      ? JSON.parse(Cookies.get("Remember"))
      : "";
    _this.LoginCode = data.LoginCode;
    _this.LoginPassword = data.LoginPassword;
    _this.remember = data.remember;
    if (_this.LoginPassword) {
      _this.inputType = "password";
    }
  },

  methods: {
    changeInputType() {
      this.inputType = "password";
    },

    // 登录
    Login() {
      let _this = this;

      let data = {
        LoginCode: _this.LoginCode,
        LoginPassword: _this.LoginPassword,
      };

      if (!data.LoginCode) {
        _this.$Message["error"]({
          background: true,
          content: "用户名不能为空",
        });
        return;
      }

      if (!data.LoginPassword) {
        _this.$Message["error"]({
          background: true,
          content: "密码不能为空",
        });
        return;
      }
      _this.loading = true;

      
      UserLogin(data)
        .then((res) => {
          _this.loading = false;
          if (res.Success) {
            // 是否记住密码
            if (_this.remember) {
              Cookies.set("Remember", {
                remember: true,
                ...data,
              });
            } else {
              Cookies.set("Remember", {
                LoginCode: _this.LoginCode,
                LoginPassword: "",
                remember: false,
              });
            }
            console.log(res.Data);
            // 保存token
            Cookies.set('Token', res.Data.token_type + ' ' + res.Data.access_token);
            Cookies.set('ssk', res.Data.access_token);
            Cookies.set('IsAdmin', res.Data.IsAdmin);
            Cookies.set('CompanyCode', res.Data.CompanyCode);
            Cookies.set('DepartmentCode', res.Data.DepartmentCode);
            Cookies.set('GroupCode', res.Data.GroupCode);
            Cookies.set('IsSuperAdmin', res.Data.IsSuperAdmin);
			Cookies.set('CompanyTitle', res.Data.CompanyTitle);
			Cookies.set('CompanyLogo', res.Data.CompanyLogo);
            _this.$router.push({
              name: "index",
            });

          } else {
            _this.$Message["error"]({
              background: true,
              content: res.Message,
            });
          }
        })
        .catch((err) => {
          _this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.login-card-input-checkbox >>> .ivu-checkbox-wrapper {
  color: #0ba1f8;
}

.login-card-input-checkbox >>> .ivu-checkbox-inner {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #0ba1f8;
}

.login-card-input-but >>> .ivu-btn {
  width: 100%;
  height: 100%;
  background-color: #0ba1f8;
  color: #ffffff;
  font-size: 16px;
  /* letter-spacing: 4px; */
  border-color: #0ba1f8;
}
</style>
<style src="./login.css" scoped></style>